export type MilestoneStatus = 'not_started' | 'in_progress' | 'completed' | 'overdue';
export type RiskSeverity = 'low' | 'medium' | 'high' | 'critical';
export type RiskStatus = 'open' | 'mitigating' | 'mitigated' | 'closed';

export const healthOptions = [
  { value: 'green', label: 'On Track', color: 'bg-green-500', bgLight: 'bg-green-50 border-green-200' },
  { value: 'yellow', label: 'At Risk', color: 'bg-yellow-500', bgLight: 'bg-yellow-50 border-yellow-200' },
  { value: 'red', label: 'Off Track', color: 'bg-red-500', bgLight: 'bg-red-50 border-red-200' },
] as const;

export const severityOptions = [
  { value: 'low', label: 'Low', color: 'text-gray-600 bg-gray-100' },
  { value: 'medium', label: 'Medium', color: 'text-yellow-700 bg-yellow-100' },
  { value: 'high', label: 'High', color: 'text-orange-700 bg-orange-100' },
  { value: 'critical', label: 'Critical', color: 'text-red-700 bg-red-100' },
] as const;

export const milestoneStatusOptions = [
  { value: 'not_started', label: 'Not Started' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'completed', label: 'Completed' },
] as const;

export const riskStatusOptions = [
  { value: 'open', label: 'Open' },
  { value: 'mitigating', label: 'Mitigating' },
  { value: 'mitigated', label: 'Mitigated' },
  { value: 'closed', label: 'Closed' },
] as const;
